import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const RecentPosts = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await axios.get("/api_w/posts", {
          headers: { db_name: process.env.REACT_APP_DB_NAME },
        });
        const allPosts = response.data.data || [];
        // Sort by date descending and take 5
        const sorted = allPosts.sort(
          (a, b) => new Date(b.date || b.createdAt) - new Date(a.date || a.createdAt)
        );
        setPosts(sorted.slice(0, 5));
      } catch (error) {
        toast.error("Gagal memuat postingan terbaru");
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, []);

  const statusBadge = (status) => {
    if (status === "published") {
      return (
        <span className="inline-flex items-center rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-800 dark:bg-green-500/20 dark:text-green-400">
          Published
        </span>
      );
    }
    return (
      <span className="inline-flex items-center rounded-full bg-yellow-100 px-2.5 py-0.5 text-xs font-medium text-yellow-800 dark:bg-yellow-500/20 dark:text-yellow-400">
        Draft
      </span>
    );
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    return new Date(dateStr).toLocaleDateString("id-ID", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <div className="flex flex-col rounded-[20px] bg-white px-6 pb-4 pt-6 shadow-xl shadow-shadow-500 dark:bg-navy-800 dark:shadow-none">
      <div className="flex items-center justify-between mb-4">
        <h4 className="text-lg font-bold text-navy-700 dark:text-white">
          Postingan Terbaru
        </h4>
        <button
          onClick={() => navigate("/admin/posts")}
          className="text-sm font-medium text-brand-500 hover:text-brand-600 transition-colors duration-150"
        >
          Lihat Semua
        </button>
      </div>

      {loading ? (
        <div className="space-y-3">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="h-12 animate-pulse rounded-lg bg-gray-100 dark:bg-navy-700" />
          ))}
        </div>
      ) : posts.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-8 text-gray-400">
          <p className="text-sm">Belum ada postingan</p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-200 dark:border-navy-700">
                <th className="pb-2 text-left text-xs font-bold uppercase tracking-wide text-gray-500 dark:text-gray-400">
                  Judul
                </th>
                <th className="pb-2 text-left text-xs font-bold uppercase tracking-wide text-gray-500 dark:text-gray-400">
                  Kategori
                </th>
                <th className="pb-2 text-left text-xs font-bold uppercase tracking-wide text-gray-500 dark:text-gray-400">
                  Status
                </th>
                <th className="pb-2 text-left text-xs font-bold uppercase tracking-wide text-gray-500 dark:text-gray-400">
                  Tanggal
                </th>
              </tr>
            </thead>
            <tbody>
              {posts.map((post) => (
                <tr
                  key={post.id}
                  onClick={() => navigate(`/admin/edit-posts/${post.id}`)}
                  className="cursor-pointer border-b border-gray-100 last:border-0 hover:bg-gray-50 dark:border-navy-700 dark:hover:bg-navy-700/50 transition-colors duration-150"
                >
                  <td className="py-3 pr-4">
                    <p className="text-sm font-medium text-navy-700 dark:text-white truncate max-w-[200px]">
                      {post.title}
                    </p>
                  </td>
                  <td className="py-3 pr-4">
                    <p className="text-sm text-gray-500 dark:text-gray-400">
                      {post.PostCategory?.name || "-"}
                    </p>
                  </td>
                  <td className="py-3 pr-4">{statusBadge(post.status)}</td>
                  <td className="py-3">
                    <p className="text-sm text-gray-500 dark:text-gray-400">
                      {formatDate(post.date)}
                    </p>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default RecentPosts;
